<template>
  <div class="dashboard-container">
    <!-- 添加装饰元素 -->
    <!-- <div class="fun-elements">
      <div class="rainbow rainbow1">🌈</div>
      <div class="rainbow rainbow2">🌈</div>
      <div class="cloud cloud1">☁️</div>
      <div class="cloud cloud2">☁️</div>
      <div class="sun">☀️</div>
      <div class="flower flower1">🌸</div>
      <div class="flower flower2">🌺</div>
      <div class="flower flower3">🌻</div>
      <div class="butterfly butterfly1">🦋</div>
      <div class="butterfly butterfly2">🦋</div>
    </div> -->

    <el-row :gutter="20">
      <el-col :span="14">
        <el-row :gutter="10" class="mt-20">
          <el-col :span="24">
            <div class="grid-content bg-purple growth-panel">
              <div class="panel-header">
                <h2>生长阶段</h2>
              </div>
              <el-steps :active="1" align-center>
                <el-step
                  v-for="item in taskInfo.stageList"
                  :key="item.stageId"
                  :title="item.stageName"
                  :description="item.stageName"
                >
                </el-step>
              </el-steps>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="mt-20">
          <el-col :span="24">
            <div class="left-grid-content bg-purple factory_show">
              <div class="dashboard-header">
                <h1>种植箱概况</h1>
                <div class="header-right-section">
                  <div class="plant-status">
                    <span
                      class="status-badge"
                      :class="isDeviceOnline ? 'ok' : 'error'"
                      >{{ isDeviceOnline ? "设备正常" : "网络异常" }}</span
                    >
                    <span class="status-time-wrap" v-if="deviceInfo && deviceInfo.greenhouseName" @click.stop>
                      <template v-if="!showPasswordInput && !editingName">
                        <span
                          class="status-time clickable"
                          @click="onTripleClick"
                          title="连续点击三次修改设备名称"
                          >{{ deviceInfo.greenhouseName }}</span
                        >
                      </template>
                      <template v-else-if="showPasswordInput">
                        <span class="inline-edit">
                          <input
                            class="password-input"
                            v-model="passwordInput"
                            placeholder="请输入暗号秘钥"
                            type="text"
                            @keyup.enter="verifyPassword"
                          />
                          <el-button type="primary" size="mini" class="confirm-btn" @click="verifyPassword">
                            <i class="el-icon-check"></i>
                          </el-button>
                        </span>
                      </template>
                      <template v-else>
                        <span class="inline-edit">
                          <input
                            class="name-input"
                            v-model="editGreenhouseName"
                            :placeholder="deviceInfo.greenhouseName || '设备名称'"
                            maxlength="20"
                            @keyup.enter="confirmEditGreenhouseName"
                          />
                          <el-button type="primary" size="mini" class="confirm-btn" @click="confirmEditGreenhouseName">
                            <i class="el-icon-check"></i>
                          </el-button>
                        </span>
                      </template>
                    </span>
                  </div>
                  <!-- 用户菜单 -->
                  <div class="user-menu-wrapper" @click.stop>
                    <div class="user-menu-trigger" @click="toggleUserMenu">
                      <i class="el-icon-user-solid"></i>
                    </div>
                    <transition name="user-menu-fade">
                      <div v-if="showUserMenu" class="user-menu-dropdown">
                        <div class="user-info">
                          <i class="el-icon-user"></i>
                          <span>{{ userName || '用户' }}</span>
                        </div>
                        <div class="menu-divider"></div>
                        <div class="menu-item logout-item" @click="handleLogout">
                          <i class="el-icon-switch-button"></i>
                          <span>退出登录</span>
                        </div>
                      </div>
                    </transition>
                  </div>
                </div>
              </div>

              <div v-if="!isDeviceOnline" class="device-alert">
                <i class="el-icon-warning"></i>
                设备当前网络异常，数据可能延迟或不可用
              </div>

              <!-- 概况可视化区域：种植箱 + 读数 + 设备状态 -->
              <div class="overview-content">
                <div class="tank-area">
                  <div class="tank" aria-label="种植箱液位">
                    <div class="tank-glass"></div>
                    <div class="tank-water" :style="waterStyle">
                      <div class="water-wave"></div>
                      <div class="water-wave second"></div>
                      <!-- 泵气泡：被水面裁剪 -->
                      <div v-if="isOxygenPumpOn" class="bubble-field">
                        <span class="bubble" style="left: 44%" />
                        <span class="bubble delay1" style="left: 48%" />
                        <span class="bubble delay2" style="left: 52%" />
                        <span class="bubble delay3" style="left: 46%" />
                        <span class="bubble delay4" style="left: 50%" />
                      </div>
                    </div>

                    <!-- 顶部照明 -->
                    <div
                      class="tank-led-top"
                      :class="{
                        active: ledSwitchOn,
                        fault:
                          isAbnormalField('ledSwitch') ||
                          isAbnormalField('ledBrightness') ||
                          isAbnormalField('ledColor'),
                      }"
                      :style="{ backgroundColor: ledColor }"
                      :title="'LED: ' + (ledSwitchOn ? '开' : '关')"
                    ></div>
                    <div
                      v-if="ledSwitchOn"
                      class="led-beam"
                      :style="ledBeamStyle"
                    ></div>
                    <!-- 顶部扬声器 -->
                    <div
                      class="device buzzer"
                      :class="{
                        active: isBuzzerOn,
                        fault: isAbnormalField('buzzer'),
                      }"
                      title="扬声器"
                    >
                      <svg
                        class="icon-buzzer"
                        viewBox="0 0 64 64"
                        aria-hidden="true"
                      >
                        <path
                          d="M8 26 h12 l12-10 v32 l-12-10 H8 z"
                          fill="#90a4ae"
                        />
                        <circle cx="46" cy="32" r="4" fill="#78909c" />
                        <g
                          class="buzzer-arcs"
                          fill="none"
                          stroke="#2196f3"
                          stroke-width="2"
                          stroke-linecap="round"
                          opacity="0.0"
                        >
                          <path d="M52 22 a14 14 0 0 1 0 20" />
                          <path d="M56 18 a20 20 0 0 1 0 28" />
                        </g>
                      </svg>
                    </div>
                    <!-- 中部风扇 -->
                    <div
                      class="device fan"
                      :class="{
                        active: isFanOn,
                        fault: isAbnormalField('fan'),
                      }"
                      title="风扇"
                      :style="{ '--fan-rotation': fanRotationDuration }"
                    >
                      <svg
                        class="icon-fan"
                        viewBox="0 0 100 100"
                        aria-hidden="true"
                      >
                        <circle cx="50" cy="50" r="8" fill="#546e7a" />
                        <g class="blades" fill="#90caf9">
                          <path
                            d="M50 12 C60 12 68 20 68 30 C68 38 62 46 54 48 C52 48 50 50 50 50 C50 50 48 48 46 48 C38 46 32 38 32 30 C32 20 40 12 50 12 Z"
                          />
                          <path
                            d="M88 50 C88 60 80 68 70 68 C62 68 54 62 52 54 C52 52 50 50 50 50 C50 50 52 48 52 46 C54 38 62 32 70 32 C80 32 88 40 88 50 Z"
                          />
                          <path
                            d="M50 88 C40 88 32 80 32 70 C32 62 38 54 46 52 C48 52 50 50 50 50 C50 50 52 52 54 52 C62 54 68 62 68 70 C68 80 60 88 50 88 Z"
                          />
                        </g>
                      </svg>
                    </div>
                    <!-- 中上部雾化器 -->
                    <div
                      class="device ultra"
                      :class="{
                        active: isUltraOn,
                        fault: isAbnormalField('ultra'),
                      }"
                      title="雾化器"
                    >
                      <svg
                        class="icon-ultra"
                        viewBox="0 0 80 60"
                        aria-hidden="true"
                      >
                        <rect
                          x="36"
                          y="36"
                          width="8"
                          height="6"
                          rx="2"
                          fill="#90caf9"
                        />
                        <g class="mist-dots" fill="rgba(255,255,255,0.9)">
                          <circle cx="40" cy="30" r="2" />
                          <circle cx="46" cy="26" r="1.8" />
                          <circle cx="34" cy="26" r="1.6" />
                          <circle cx="42" cy="22" r="1.4" />
                          <circle cx="38" cy="18" r="1.2" />
                        </g>
                      </svg>
                    </div>
                    <!-- 底部增氧泵 -->
                    <div
                      class="device pump"
                      :class="{
                        active: isOxygenPumpOn,
                        fault: isAbnormalField('oxygenpump'),
                      }"
                      title="增氧泵"
                    >
                      <svg
                        class="icon-pump"
                        viewBox="0 0 80 40"
                        aria-hidden="true"
                      >
                        <rect
                          x="27"
                          y="18"
                          width="26"
                          height="12"
                          rx="6"
                          fill="#64b5f6"
                          stroke="#1e88e5"
                          stroke-width="1"
                        />
                        <rect
                          x="20"
                          y="21"
                          width="7"
                          height="6"
                          rx="3"
                          fill="#64b5f6"
                        />
                        <rect
                          x="53"
                          y="21"
                          width="7"
                          height="6"
                          rx="3"
                          fill="#64b5f6"
                        />
                      </svg>
                    </div>
                  </div>
                  <div class="tank-meta">
                    <span>液位高度：{{ waterLevelDisplay }}</span>
                  </div>
                </div>

                <div class="readings-area">
                  <!-- 传感器信息区域 -->
                  <div class="sensor-section">
                    <div class="group-title">传感器</div>
                    <div class="big-metrics">
                      <div class="metric">
                        <div class="label">空气温度</div>
                        <div
                          class="value"
                          :class="{ fault: isAbnormalField('temp') }"
                        >
                          {{
                            isAbnormalField("temp")
                              ? "设备异常｜提醒维修"
                              : formatTemp(greenhouseData.temp) + "°C"
                          }}
                        </div>
                      </div>
                      <div class="metric">
                        <div class="label">水温度</div>
                        <div
                          class="value"
                          :class="{ fault: isAbnormalField('w_temp') }"
                        >
                          {{
                            isAbnormalField("w_temp")
                              ? "设备异常｜提醒维修"
                              : formatTemp(greenhouseData.w_temp) + "°C"
                          }}
                        </div>
                      </div>
                      <div class="metric">
                        <div class="label">湿度</div>
                        <div
                          class="value"
                          :class="{ fault: isAbnormalField('hum') }"
                        >
                          {{
                            isAbnormalField("hum")
                              ? "设备异常｜提醒维修"
                              : greenhouseData.hum + "%"
                          }}
                        </div>
                      </div>
                      <div class="metric">
                        <div class="label">水位</div>
                        <div
                          class="value"
                          :class="{ fault: isAbnormalField('liquid') }"
                        >
                          {{
                            isAbnormalField("liquid")
                              ? "设备异常｜提醒维修"
                              : greenhouseData.liquid + "%"
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="small-metrics">
                      <div class="small-item">
                        <i class="el-icon-sunny"></i>
                        <span>光照</span>
                        <b :class="{ fault: isAbnormalField('light') }">{{
                          isAbnormalField("light")
                            ? "设备异常｜提醒维修"
                            : greenhouseData.light + " lux"
                        }}</b>
                      </div>
                      <div class="small-item">
                        <i class="el-icon-gas-station"></i>
                        <span>二氧化碳</span>
                        <b :class="{ fault: isAbnormalField('co2') }">{{
                          isAbnormalField("co2")
                            ? "设备异常｜提醒维修"
                            : greenhouseData.co2 + " ppm"
                        }}</b>
                      </div>
                      <div class="small-item">
                        <i class="el-icon-odometer"></i>
                        <span>TDS</span>
                        <b :class="{ fault: isAbnormalField('TDS') }">{{
                          isAbnormalField("TDS")
                            ? "设备异常｜提醒维修"
                            : greenhouseData.TDS + " ppm"
                        }}</b>
                      </div>
                      <div class="small-item">
                        <i class="el-icon-connection"></i>
                        <span>电导率</span>
                        <b :class="{ fault: isAbnormalField('EC') }">{{
                          isAbnormalField("EC")
                            ? "设备异常｜提醒维修"
                            : greenhouseData.EC + " μS/cm"
                        }}</b>
                      </div>
                      <div class="small-item">
                        <i class="el-icon-salt"></i>
                        <span>盐度</span>
                        <b :class="{ fault: isAbnormalField('salinity') }">{{
                          isAbnormalField("salinity")
                            ? "设备异常｜提醒维修"
                            : greenhouseData.salinity + " ppt"
                        }}</b>
                      </div>
                      <div class="small-item">
                        <i class="el-icon-scale-to-original"></i>
                        <span>比重</span>
                        <b :class="{ fault: isAbnormalField('SG') }">{{
                          isAbnormalField("SG")
                            ? "设备异常｜提醒维修"
                            : greenhouseData.SG.toFixed(3)
                        }}</b>
                      </div>
                    </div>
                  </div>

                  <!-- 设备信息区域 -->
                  <div class="device-section">
                    <div class="group-title">设备</div>
                    <div class="small-metrics">
                      <div class="small-item">
                        <i class="el-icon-wind-power"></i>
                        <span>风扇</span>
                        <b :class="{ fault: isAbnormalField('fan') }">{{
                          isAbnormalField("fan")
                            ? "设备异常｜提醒维修"
                            : fanLevelName
                        }}</b>
                      </div>
                      <div class="small-item">
                        <i class="el-icon-cpu"></i>
                        <span>增氧泵</span>
                        <b
                          :class="{ fault: isAbnormalField('oxygenpump') }"
                          >{{
                            isAbnormalField("oxygenpump")
                              ? "设备异常｜提醒维修"
                              : oxygenPumpLevelName
                          }}</b
                        >
                      </div>
                      <div class="small-item">
                        <i class="el-icon-odometer"></i>
                        <span>雾化器</span>
                        <b :class="{ fault: isAbnormalField('ultra') }">{{
                          isAbnormalField("ultra")
                            ? "设备异常｜提醒维修"
                            : ultraLevelName
                        }}</b>
                      </div>
                      <div class="small-item">
                        <i class="el-icon-bell"></i>
                        <span>扬声器</span>
                        <b :class="{ fault: isAbnormalField('buzzer') }">{{
                          isAbnormalField("buzzer")
                            ? "设备异常｜提醒维修"
                            : isBuzzerOn
                            ? "运行中"
                            : "关闭"
                        }}</b>
                      </div>
                      <div class="small-item">
                        <i class="el-icon-lightning"></i>
                        <span>照明</span>
                        <b
                          :class="{
                            fault:
                              isAbnormalField('ledSwitch') ||
                              isAbnormalField('ledBrightness') ||
                              isAbnormalField('ledColor'),
                          }"
                          >{{
                            isAbnormalField("ledSwitch") ||
                            isAbnormalField("ledBrightness") ||
                            isAbnormalField("ledColor")
                              ? "设备异常｜提醒维修"
                              : ledSwitchOn
                              ? "亮度" + (greenhouseData.ledBrightness || 0)
                              : "关闭"
                          }}</b
                        >
                      </div>
                      <div class="small-item">
                        <i class="el-icon-takeaway-box"></i>
                        <span>水泵</span>
                        <b :class="{ fault: isAbnormalField('waterpump') }">{{
                          isAbnormalField("waterpump")
                            ? "设备异常｜提醒维修"
                            : isWaterPumpOn
                            ? "运行中"
                            : "关闭"
                        }}</b>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>

      <el-col :span="10">
        <el-row :gutter="10" class="mt-20">
          <el-col :span="24">
            <div class="grid-content bg-purple task-panel">
              <div class="panel-header">
                <h2>当前任务</h2>
                <el-button type="primary" size="small" @click="gotoCoding()">
                  <i class="el-icon-edit"></i> 种植实操
                </el-button>
              </div>

              <div class="task-list">
                <div
                  v-for="item in jobs"
                  :key="item.assignmentId"
                  class="task-item"
                >
                  <div class="task-content">
                    <i class="el-icon-check"></i>
                    <span>{{ item.taskDescription }}</span>
                  </div>
                  <router-link
                    v-if="item.course"
                    :to="{
                      name: 'coursedetail',
                      params: {
                        courseId: item.course.courseId,
                        assignmentId: item.assignmentId,
                      },
                    }"
                    class="task-link"
                  >
                    查看讲解
                  </router-link>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
        <el-row :gutter="10" class="mt-20">
          <el-col :span="24">
            <div class="grid-content bg-purple record-panel">
              <div class="panel-header">
                <h2>观看记录</h2>
                <el-button type="primary" size="small" @click="gotoCourseHome">
                  <i class="el-icon-video-play"></i> 观看视频
                </el-button>
              </div>

              <div class="record-list">
                <div
                  v-for="item in courseRecords"
                  :key="item.courseRecordId"
                  class="record-item"
                  @click="gotoCourseDetail(item.courseId, item.courseRecordId)"
                >
                  <i class="el-icon-video-camera"></i>
                  <span>{{ item.courseName }}</span>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="mt-20">
          <el-col :span="24">
            <div class="grid-content bg-purple record-panel">
              <div class="panel-header">
                <h2>操作记录</h2>
                <el-button type="primary" size="small" @click="gotoCoding()">
                  <i class="el-icon-video-play"></i> 种植实操
                </el-button>
              </div>

              <div class="record-list">
                <div
                  v-for="item in codingRecords"
                  :key="item.codingRecordId"
                  class="record-item"
                  @click="gotoCoding(item.codingRecordId)"
                >
                  <i class="el-icon-video-camera"></i>
                  <span>
                    {{
                      item.taskDescription
                        ? item.taskDescription
                        : item.videoName
                        ? item.videoName
                        : item.recordDate
                        ? formatDate(item.recordDate) + " 练习"
                        : "程序示例"
                    }}
                  </span>
                </div>
              </div>
            </div>
          </el-col>
        </el-row>
      </el-col>
    </el-row>

    <!-- <el-row :gutter="20" class="mt-20">
      <el-col :span="12">
        <div class="grid-content bg-purple growth-panel">
          <div class="panel-header">
            <h2>生长阶段</h2>
          </div>
          <el-steps :active="1" align-center>
            <el-step
              v-for="item in taskInfo.stageList"
              :key="item.stageId"
              :title="item.stageName"
              :description="item.stageName"
            >
            </el-step>
          </el-steps>
        </div>
      </el-col>
      
      <el-col :span="12">
        
      </el-col>
    </el-row> -->

    <el-dialog
      title="选择种植作物"
      :visible.sync="taskAddShow"
      width="80%"
      custom-class="crop-select-dialog"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div class="crop-select-container">
        <div class="crop-select-header">
          <h3>请选择要种植的作物</h3>
          <p class="selected-crop" v-if="crop.cropName">
            已选择：<span>{{ crop.cropName }}</span>
          </p>
        </div>

        <el-carousel
          :interval="4000"
          type="card"
          height="280px"
          :autoplay="false"
          indicator-position="outside"
          arrow="always"
        >
          <el-carousel-item v-for="item in cropList" :key="item.cropId">
            <div class="crop-card" @click="choseCrop(item)">
              <div class="crop-image">
                <i class="el-icon-food"></i>
              </div>
              <div class="crop-info">
                <h4>{{ item.cropName }}</h4>
                <p class="crop-desc">点击选择种植此作物</p>
              </div>
            </div>
          </el-carousel-item>
        </el-carousel>

        <div class="dialog-footer">
          <div class="button-group">
            <el-button @click="taskAddShow = false" plain class="cancel-btn">
              <i class="el-icon-close"></i>
              取消
            </el-button>
            <el-button
              type="primary"
              @click="addTask()"
              :disabled="!crop.cropName"
              class="confirm-btn"
            >
              <i class="el-icon-check"></i>
              开始种植
            </el-button>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
  
<script>
export default {
  data() {
    return {
      searchFormData: {
        cropId: "",
        cropName: "",
        categoryId: "",
        plantingSeason: "",
        harvestSeason: "",
        growthPeriod: "",
        plantingDepth: "",
        irrigationFrequency: "",
        fertilizerRequirements: "",
        diseaseResistance: "",
        createdAt: "",
        unitYield: "",
        expiryDays: "",
        pageIndex: 1,
        pageSize: 10,
      },
      pageInfo: {
        rows: [],
        total: 0,
      },
      dialogVisible: false,
      dialogTitle: "",
      dialogFormData: {
        cropId: "",
        cropName: "",
        categoryId: "",
        plantingSeason: "",
        harvestSeason: "",
        growthPeriod: "",
        plantingDepth: "",
        irrigationFrequency: "",
        fertilizerRequirements: "",
        diseaseResistance: "",
        createdAt: "",
        unitYield: "",
        expiryDays: "",
      },
      itemList: [
        {
          id: 1,
        },
        {
          id: 2,
        },
        {
          id: 3,
        },
        {
          id: 4,
        },
      ],
      greenhouseData: {
        hum: 0,
        temp: 0,
        w_temp: 0,
        fan: 0,
        liquid: 0,
        buzzer: 0,
        light: 0,
        TDS: 0,
        EC: 0,
        salinity: 0,
        SG: 0,
        co2: 0,
        ledSwitch: 0,
        ledBrightness: 0,
        ledColor: "#9e9e9e",
        oxygenpump: 0,
        waterpump: 0,
        ultra: 0,
      },
      deviceInfo: null,
      greenhouseStatus: 0,
      jobs: [],
      courseRecords: [],
      taskInfo: {},
      codingRecords: [],
      userId: "",
      userName: "",
      greenhouseId: "",
      taskAddShow: false,
      crop: {},
      cropList: [],
      prevAbnormalKeys: [],
      editingName: false,
      editGreenhouseName: '',
      clickCount: 0,
      clickTimer: null,
      showPasswordInput: false,
      passwordInput: '',
      showUserMenu: false,
    };
  },
  created() {
    // localStorage.setItem("ms_userId",null);
    this.userId = localStorage.getItem("ms_userId");
    this.userName = localStorage.getItem("ms_username");
    this.greenhouseId = localStorage.getItem("ms_greenhouseId");
    if (!this.userId) {
      this.$router.push("/login");
    }
    this.getAllCrop();
    //   this.loadTable();

    //没有温室调到学习页
    if (!this.greenhouseId) {
      // this.$router.push("/coursevideo");
    }
    this.loadOtherInfo();
    this.loadGreenhouseInfo();
  },
  mounted() {
    // cockpit1 页面进入动画
    this.enterAnimation();
    // 启动轮询实时刷新设备状态
    this._pollTimer = setInterval(() => {
      this.loadGreenhouseInfo();
    }, 10000);
    document.addEventListener('click', this._onDocumentClick, true);
  },
  beforeDestroy() {
    if (this._pollTimer) {
      clearInterval(this._pollTimer);
      this._pollTimer = null;
    }
    document.removeEventListener('click', this._onDocumentClick, true);
  },
  activated() {
    window.localStorage.removeItem("courseId");
    window.localStorage.removeItem("codingRecordId");
    window.localStorage.removeItem("assignmentId");
  },
  computed: {
    isDeviceOnline() {
      return Number(this.greenhouseStatus) === 0;
    },
    isFanOn() {
      const value = this.greenhouseData.fan;
      if (this.isAbnormalField("fan")) return false;
      return Number(value) > 0;
    },
    isOxygenPumpOn() {
      if (this.isAbnormalField("oxygenpump")) return false;
      return Number(this.greenhouseData.oxygenpump) > 0;
    },
    isWaterPumpOn() {
      if (this.isAbnormalField("waterpump")) return false;
      return Number(this.greenhouseData.waterpump) === 1;
    },
    isUltraOn() {
      const value = this.greenhouseData.ultra;
      if (this.isAbnormalField("ultra")) return false;
      return Number(value) > 0;
    },
    isBuzzerOn() {
      if (this.isAbnormalField("buzzer")) return false;
      return Number(this.greenhouseData.buzzer) === 1;
    },
    ledSwitchOn() {
      if (
        this.isAbnormalField("ledSwitch") ||
        this.isAbnormalField("ledBrightness") ||
        this.isAbnormalField("ledColor")
      )
        return false;
      return Number(this.greenhouseData.ledSwitch) === 1;
    },
    ledColor() {
      const color = this.greenhouseData.ledColor || "#9e9e9e";
      return color;
    },
    ledBeamStyle() {
      // brightness: 0,33,66,99 => 0, .35, .7, 1
      if (
        this.isAbnormalField("ledSwitch") ||
        this.isAbnormalField("ledBrightness") ||
        this.isAbnormalField("ledColor")
      ) {
        return { background: "transparent" };
      }
      const b = Number(this.greenhouseData.ledBrightness) || 0;
      const opacity = b >= 99 ? 1 : b >= 66 ? 0.7 : b >= 33 ? 0.35 : 0.0;
      const rgbaTop = this.hexToRgba(this.ledColor, 0.28 * opacity);
      const rgbaMid = this.hexToRgba(this.ledColor, 0.06 * opacity);
      return {
        background: `linear-gradient(180deg, ${rgbaTop}, ${rgbaMid} 40%, transparent 70%)`,
      };
    },
    fanLevelName() {
      return this.levelName(this.greenhouseData.fan);
    },
    ultraLevelName() {
      return this.levelName(this.greenhouseData.ultra);
    },
    oxygenPumpLevelName() {
      return this.levelName(this.greenhouseData.oxygenpump);
    },
    fanRotationDuration() {
      if (this.isAbnormalField("fan")) return "0s";
      const v = Number(this.greenhouseData.fan) || 0;
      if (v >= 99) return "0.5s";
      if (v >= 66) return "0.8s";
      if (v >= 33) return "1.2s";
      return "0s";
    },
    bubbleSpeed() {
      if (this.isAbnormalField("oxygenpump")) return "0s";
      const v = Number(this.greenhouseData.oxygenpump) || 0;
      if (v >= 99) return "1.2s";
      if (v >= 66) return "1.6s";
      if (v >= 33) return "2.2s";
      return "0s";
    },
    waterStyle() {
      return {
        height: this.waterLevelPercent + "%",
        "--bubble-speed": this.bubbleSpeed,
      };
    },
    waterLevelPercent() {
      let level = this.greenhouseData.liquid;
      console.log("level", level);
      if (typeof level !== "number" || isNaN(level)) return 0;
      let fraction = level <= 1 ? level : level / 100;
      const pct = Math.max(0, Math.min(100, Math.round(fraction * 100)));
      console.log("pct", pct);
      return pct;
    },
    waterLevelDisplay() {
      const level = Number(this.greenhouseData.liquid);
      if (!isFinite(level)) return "-";
      if (level < 1) {
        return level.toFixed(3);
      }
      console.log("level2", level);
      return level.toFixed(1);
    },
  },
  methods: {
    onTripleClick() {
      this.clickCount++;
      if (this.clickTimer) {
        clearTimeout(this.clickTimer);
      }
      
      if (this.clickCount === 3) {
        this.clickCount = 0;
        this.showPasswordInput = true;
        this.passwordInput = '';
        this.$nextTick(() => {
          try {
            const el = this.$el.querySelector('.password-input');
            el && el.focus();
          } catch (err) {
            console.log(err);
          }
        });
      } else {
        this.clickTimer = setTimeout(() => {
          this.clickCount = 0;
        }, 1000);
      }
    },
    verifyPassword() {
      if (this.passwordInput === '般若波罗蜜') {
        this.showPasswordInput = false;
        this.editingName = true;
        this.editGreenhouseName = (this.deviceInfo && this.deviceInfo.greenhouseName) || '';
        this.$nextTick(() => {
          try {
            const el = this.$el.querySelector('.name-input');
            el && el.focus();
          } catch (err) {
            console.log(err);
          }
        });
      } else {
        this.$message && this.$message.error('暗号秘钥错误');
        this.showPasswordInput = false;
        this.passwordInput = '';
      }
    },
    _onDocumentClick(evt) {
      try {
        // 处理编辑名称和密码输入的外部点击
        if (this.editingName || this.showPasswordInput) {
          const editor = this.$el && this.$el.querySelector('.inline-edit');
          if (editor && editor.contains(evt.target)) return;
          this.editingName = false;
          this.showPasswordInput = false;
          this.passwordInput = '';
        }
        
        // 处理用户菜单的外部点击
        if (this.showUserMenu) {
          const userMenuWrapper = this.$el && this.$el.querySelector('.user-menu-wrapper');
          if (userMenuWrapper && !userMenuWrapper.contains(evt.target)) {
            this.showUserMenu = false;
          }
        }
      } catch (err) {
        console.log(err);
      }
    },
    async confirmEditGreenhouseName() {
      try {
        const oldName = (this.deviceInfo && this.deviceInfo.greenhouseName) || '';
        const trimmed = String(this.editGreenhouseName || '').trim();
        if (!trimmed) {
          this.$message && this.$message.warning('设备名称不能为空');
          return;
        }
        if (trimmed === oldName) {
          this.editingName = false;
          return;
        }
        const payload = {
          greenhouseId: this.greenhouseId,
          greenhouseName: trimmed,
        };
        await this.$request.callApi('POST', this.$robotApi.updateGreenhouse, payload);
        if (!this.deviceInfo) this.deviceInfo = {};
        this.$set(this.deviceInfo, 'greenhouseName', trimmed);
        this.$message && this.$message.success('设备名称已更新');
        this.editingName = false;
      } catch (err) {
        console.warn('updateGreenhouse failed', err);
        this.$message && this.$message.error('设备名称更新失败');
      }
    },
    cancelEditGreenhouseName() {
      this.editingName = false;
      this.showPasswordInput = false;
      this.passwordInput = '';
    },
    isAbnormalField(key) {
      const value = this.greenhouseData && this.greenhouseData[key];
      if (value === undefined || value === null) return false;
      if (typeof value === "number") return Number(value) === -50;
      if (typeof value === "string") return value === "-50";
      return false;
    },
    levelName(value) {
      const v = Number(value) || 0;
      if (v >= 99) return "三挡";
      if (v >= 66) return "二挡";
      if (v >= 33) return "一档";
      return "关闭";
    },
    hexToRgba(hex, alpha) {
      let h = hex.replace("#", "");
      if (h.length === 3) {
        h = h
          .split("")
          .map((c) => c + c)
          .join("");
      }
      const bigint = parseInt(h, 16);
      const r = (bigint >> 16) & 255;
      const g = (bigint >> 8) & 255;
      const b = bigint & 255;
      return `rgba(${r}, ${g}, ${b}, ${alpha})`;
    },
    playBeep() {
      try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!AudioContext) return;
        const ctx = new AudioContext();
        const oscillator = ctx.createOscillator();
        const gain = ctx.createGain();
        oscillator.type = "sine";
        oscillator.frequency.setValueAtTime(880, ctx.currentTime);
        gain.gain.setValueAtTime(0.0001, ctx.currentTime);
        gain.gain.exponentialRampToValueAtTime(0.2, ctx.currentTime + 0.01);
        gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + 0.25);
        oscillator.connect(gain);
        gain.connect(ctx.destination);
        oscillator.start();
        oscillator.stop(ctx.currentTime + 0.3);
        setTimeout(() => {
          try {
            ctx.close();
          } catch (err) {
            console.warn("AudioContext close failed", err);
          }
        }, 400);
      } catch (err) {
        console.warn("playBeep failed", err);
      }
    },
    enterAnimation() {
      // 为 cockpit1 页面元素添加进入动画
      const elements = document.querySelectorAll(
        ".grid-content, .left-grid-content, .fun-elements > *"
      );
      elements.forEach((el, index) => {
        el.style.opacity = "0";
        el.style.transform = "translateY(40px) scale(0.9)";
        el.style.transition = "all 0.2s cubic-bezier(0.68, -0.55, 0.27, 1.55)";

        setTimeout(() => {
          el.style.opacity = "1";
          el.style.transform = "translateY(0) scale(1)";
        }, index * 70);
      });
    },
    loadOtherInfo() {
      this.getTaskInfo();
      this.getTaskJobs();
      this.getCourseRecords();
      this.getCodingRecords();
    },
    formatDate(date) {
      /// 如果是字符串，尝试转换为日期对象
      if (typeof date === "string") {
        // 尝试解析常见格式的日期字符串
        const parsedDate = new Date(date);
        if (!isNaN(parsedDate.getTime())) {
          date = parsedDate;
        } else {
          // 无法解析则返回原始字符串
          return date;
        }
      }

      // 如果是日期对象
      if (date instanceof Date) {
        const month = (date.getMonth() + 1).toString().padStart(2, "0");
        const day = date.getDate().toString().padStart(2, "0");
        const hours = date.getHours().toString().padStart(2, "0");
        const minutes = date.getMinutes().toString().padStart(2, "0");

        return `${month}月${day}日 ${hours}:${minutes}`;
      }

      // 其他类型直接返回
      return date;
    },

    loadTable() {
      this.$request
        .callApi(
          "GET",
          this.$robotApi.plantingCropInfoList,
          this.searchFormData
        )
        .then((res) => {
          this.pageInfo.rows = res.data;
        });
    },
    loadGreenhouseInfo() {
      this.$request
        .callApi("GET", this.$robotApi.sensorInfo, {
          greenhouseId: this.greenhouseId,
        })
        .then((res) => {
          if (res.data) {
            // 新增设备状态处理
            if (res.data.device) {
              this.deviceInfo = res.data.device;
              this.greenhouseStatus = res.data.device.greenhouseStatus;
            }
            const cv =
              (res.data.envData &&
                res.data.envData[0] &&
                res.data.envData[0].currentValue) ||
              {};
            this.greenhouseData = {
              hum: typeof cv.hum === "number" ? cv.hum : 0,
              temp:
                typeof cv.temp === "number"
                  ? cv.temp.toFixed(1) // 若本身是数字，直接保留1位小数
                  : typeof cv.tempe === "string"
                  ? Number(cv.tempe).toFixed(1) // 若 cv.tempe 是字符串，先转数值再格式化
                  : (Number(cv.temp) || 19).toFixed(1), // 针对你的场景：cv.temp是字符串，转数值后格式化（默认19）
              w_temp: typeof cv.w_temp === "number" ? cv.w_temp.toFixed(1) : 0,
              fan: Number(cv.fan) || 0,
              liquid: typeof cv.liquid === "number" ? cv.liquid : 25,
              buzzer: Number(cv.buzzer) || 0,
              light: Number(cv.light) || 0,
              TDS: Number(cv.TDS) || 0,
              EC: Number(cv.EC) || 0,
              salinity: Number(cv.salinity) || 0,
              SG: Number(cv.SG) || 0,
              co2: Number(cv.co2) || 0,
              ledSwitch: Number(cv.ledSwitch) || 0,
              ledBrightness: Number(cv.ledBrightness) || 0,
              ledColor:
                typeof cv.ledColor === "string" ? cv.ledColor : "#9e9e9e",
              oxygenpump: Number(cv.oxygenpump || cv.pump) || 0,
              waterpump: Number(cv.waterpump) || 0,
              ultra: Number(cv.ultra) || 0,
            };
            console.log(this.greenhouseData);
            // 检测新增异常项并提示
            try {
              const keysToCheck = [
                "hum",
                "temp",
                "w_temp",
                "fan",
                "liquid",
                "buzzer",
                "light",
                "TDS",
                "EC",
                "salinity",
                "SG",
                "co2",
                "ledSwitch",
                "ledBrightness",
                "ledColor",
                "oxygenpump",
                "waterpump",
                "ultra",
              ];
              const currentAbnormal = keysToCheck.filter((k) =>
                this.isAbnormalField(k)
              );
              const prev = this.prevAbnormalKeys || [];
              const newlyAbnormal = currentAbnormal.filter(
                (k) => !prev.includes(k)
              );
              if (newlyAbnormal.length > 0) {
                this.playBeep();
                if (this.$message) {
                  this.$message.warning(
                    "检测到设备异常：" +
                      newlyAbnormal.join("、") +
                      "｜请及时维修"
                  );
                }
              }
              this.prevAbnormalKeys = currentAbnormal;
            } catch (e) {
              console.warn("abnormal detection check failed", e);
            }
          }
        });
    },
    formatTemp(value) {
      if (value === null || value === undefined || isNaN(Number(value)))
        return "-";
      try {
        return Number(value).toFixed(1);
      } catch (e) {
        return value;
      }
    },
    getTaskJobs() {
      this.$request
        .callApi("GET", this.$robotApi.taskJobs, { userId: this.userId })
        .then((res) => {
          this.jobs = res.data;
        });
    },
    addTask() {
      this.$request
        .callApi("POST", this.$robotApi.addTask, {
          cropId: this.crop.cropId,
          cropName: this.crop.cropName,
          responsiblePersonId: this.userId,
        })
        .then((res) => {
          if (res.data) {
            this.taskAddShow = false;
            this.getTaskInfo();
            this.getTaskJobs();
          }
        });
    },
    getTaskInfo() {
      this.$request
        .callApi("GET", this.$robotApi.taskInfo, {
          userId: this.userId,
          taskStatus: 2,
        })
        .then((res) => {
          if (res.data && res.data.length > 0) {
            this.taskInfo = res.data[0];
          } else {
            this.taskAddShow = true;
          }
        });
    },
    getCourseRecords() {
      this.$request
        .callApi("GET", this.$robotApi.courseRecordList, {
          userId: this.userId,
        })
        .then((res) => {
          this.courseRecords = res.data;
        });
    },
    getCodingRecords() {
      this.$request
        .callApi("GET", this.$robotApi.getCodingRecords, {
          userId: this.userId,
        })
        .then((res) => {
          this.codingRecords = res.data;
        });
    },
    getAllCrop() {
      this.$request.callApi("GET", this.$robotApi.allCrop).then((res) => {
        this.cropList = res.data;
      });
    },
    choseCrop(chos) {
      console.log(chos);
      this.crop = chos;
    },
    gotoCode() {
      this.$router.push({
        path: "/Game/game",
      });
    },
    gotoCourseDetail(courseId, courseRecordId) {
      console.log(courseId);
      this.$router.push({
        name: "coursedetail",
        params: {
          courseId: courseId,
          courseRecordId: courseRecordId,
        },
      });
    },
    gotoCourseHome() {
      this.$router.push({
        path: "/coursehome",
      });
    },
    gotoCoding(codingRecordId) {
      //打开编程页
      this.storInfo(2, "", codingRecordId, "");
      // this.storInfo(3,"","","assmiddddddd");
      this.$router.push({
        path: "/Game/scratch",
        query: {
          codingRecordId: codingRecordId,
        },
      });
    },
    storInfo(type, courseId, codingRecordId, assignmentId) {
      window.localStorage.setItem("userId", this.userId);
      window.localStorage.setItem("userName", this.userName);
      window.localStorage.setItem("avatar", "");
      //1 课程学习跳转  2编程记录跳转  3种植任务跳转
      window.localStorage.setItem("codeType", type);
      if (type === 1) {
        window.localStorage.setItem("courseId", courseId);
        window.localStorage.removeItem("codingRecordId");
        window.localStorage.removeItem("assignmentId");
      } else if (type === 2) {
        window.localStorage.removeItem("courseId");
        window.localStorage.setItem("codingRecordId", codingRecordId);
        window.localStorage.removeItem("assignmentId");
      } else if (type === 3) {
        window.localStorage.removeItem("courseId");
        window.localStorage.removeItem("codingRecordId");
        window.localStorage.setItem("assignmentId", assignmentId);
      }
    },
    onTableUpdate(row) {
      this.dialogTitle = "修改";
      this.dialogVisible = true;
      this.$nextTick(() => {
        Object.assign(this.dialogFormData, row);
      });
    },
    onTableDelete(row) {
      this.$confirm(`确认要删除该记录吗？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        const param = {
          cropId: row.cropId,
        };

        this.$request
          .callApi("POST", this.$robotApi.plantingCropInfoDel, param)
          .then(() => {
            this.$message.success("删除成功");
            this.loadTable();
          });
      });
    },
    onDialogSave() {
      this.$refs.dialogForm.validate((valid) => {
        if (valid) {
          const uri = this.dialogFormData.cropId
            ? this.$robotApi.plantingCropInfoUpdate
            : this.$robotApi.plantingCropInfoAdd;
          this.$request.callApi("POST", uri, this.dialogFormData).then(() => {
            this.dialogVisible = false;
            this.loadTable();
          });
        }
      });
    },
    onSizeChange(size) {
      this.searchFormData.pageSize = size;
      this.loadTable();
    },
    onAdd() {
      this.dialogTitle = "新增";
      this.dialogVisible = true;
      this.dialogFormData.cropId = 0;
    },
    onPageIndexChange(pageIndex) {
      this.searchFormData.pageIndex = pageIndex;
      this.loadTable();
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    toggleUserMenu() {
      this.showUserMenu = !this.showUserMenu;
    },
    handleLogout() {
      this.$confirm('确认退出登录？', '提示', {
        confirmButtonText: '退出',
        cancelButtonText: '取消',
        type: 'warning'
      })
      .then(() => {
        this.clearLoginCache();
        this.$message.success('已退出登录');
        this.$router.push('/login');
      })
      .catch(() => {
        this.showUserMenu = false;
      });
    },
    clearLoginCache() {
      const keys = [
        'ms_username',
        'ms_userId',
        'ms_lastLoginTime',
        'ms_greenhouseId',
        'userId',
        'userName',
        'avatar',
        'codeType',
        'courseId',
        'codingRecordId',
        'assignmentId',
        'videoCourseId',
        'videoAssignmentId'
      ];
      keys.forEach(key => localStorage.removeItem(key));
    },
  },
};
</script>   

<style>
.dashboard-container {
  padding: 15px;
  background: #f0f2f5;
  min-height: 100vh;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

/* 童趣装饰元素 */
.fun-elements {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
  z-index: 1;
}

.rainbow {
  position: absolute;
  font-size: 60px;
  animation: floatRainbow 2s ease-in-out infinite;
}

.rainbow.rainbow1 {
  top: 5%;
  left: 5%;
  animation-delay: 0s;
}

.rainbow.rainbow2 {
  top: 15%;
  right: 10%;
  animation-delay: 2s;
}

.cloud {
  position: absolute;
  font-size: 40px;
  animation: floatCloud 4s ease-in-out infinite;
}

.cloud.cloud1 {
  top: 25%;
  left: 15%;
  animation-delay: 0.3s;
}

.cloud.cloud2 {
  top: 35%;
  right: 20%;
  animation-delay: 2s;
}

.sun {
  position: absolute;
  font-size: 50px;
  top: 10%;
  right: 5%;
  animation: rotateSun 5s linear infinite;
}

.flower {
  position: absolute;
  font-size: 30px;
  animation: swayFlower 2s ease-in-out infinite;
}

.flower.flower1 {
  bottom: 20%;
  left: 10%;
  animation-delay: 0.3s;
}

.flower.flower2 {
  bottom: 30%;
  right: 15%;
  animation-delay: 1s;
}

.flower.flower3 {
  bottom: 25%;
  left: 50%;
  animation-delay: 2s;
}

.butterfly {
  position: absolute;
  font-size: 25px;
  animation: flutterButterfly 4s ease-in-out infinite;
}

.butterfly.butterfly1 {
  top: 40%;
  left: 20%;
  animation-delay: 0s;
}

.butterfly.butterfly2 {
  top: 50%;
  right: 25%;
  animation-delay: 6s;
}

@keyframes floatRainbow {
  0%,
  100% {
    transform: translateY(0) rotate(0deg);
  }
  50% {
    transform: translateY(-40px) rotate(10deg);
  }
}

@keyframes floatCloud {
  0%,
  100% {
    transform: translateX(0) scale(1);
  }
  50% {
    transform: translateX(30px) scale(1.1);
  }
}

@keyframes rotateSun {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes swayFlower {
  0%,
  100% {
    transform: rotate(-5deg);
  }
  50% {
    transform: rotate(5deg);
  }
}

@keyframes flutterButterfly {
  0%,
  100% {
    transform: translateY(0) translateX(0) rotate(0deg);
  }
  25% {
    transform: translateY(-20px) translateX(10px) rotate(10deg);
  }
  50% {
    transform: translateY(-10px) translateX(-10px) rotate(-10deg);
  }
  75% {
    transform: translateY(-30px) translateX(5px) rotate(5deg);
  }
}

.mt-20 {
  margin-top: 8px;
}

.grid-content {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  padding: 15px;
  transition: all 0.3s ease;
  max-height: 350px;
  overflow: auto;
}

.left-grid-content {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  padding: 15px;
  transition: all 0.3s ease;
}
.left-grid-content:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.grid-content:hover {
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.dashboard-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.dashboard-header h1 {
  color: #2c3e50;
  font-size: 1.4em;
  font-weight: 600;
  margin: 0;
}

.header-right-section {
  display: flex;
  align-items: center;
  gap: 15px;
}

.plant-status {
  display: flex;
  gap: 10px;
  align-items: center;
}

/* 用户菜单样式 */
.user-menu-wrapper {
  position: relative;
}

.user-menu-trigger {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background: #f0f2f5;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: #606266;
  font-size: 18px;
}

.user-menu-trigger:hover {
  background: #e4e7ed;
  color: #409eff;
}

.user-menu-dropdown {
  position: absolute;
  top: 45px;
  right: 0;
  min-width: 160px;
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.15);
  padding: 8px 0;
  z-index: 1000;
  overflow: hidden;
}

.user-info {
  padding: 10px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  color: #606266;
  font-size: 14px;
}

.user-info i {
  font-size: 16px;
  color: #909399;
}

.menu-divider {
  height: 1px;
  background: #e4e7ed;
  margin: 4px 0;
}

.menu-item {
  padding: 10px 16px;
  display: flex;
  align-items: center;
  gap: 8px;
  cursor: pointer;
  transition: background-color 0.3s;
  color: #606266;
  font-size: 14px;
}

.menu-item:hover {
  background: #f5f7fa;
}

.logout-item {
  color: #f56c6c;
}

.logout-item:hover {
  background: #fef0f0;
  color: #f56c6c;
}

.logout-item i {
  font-size: 16px;
}

.user-menu-fade-enter-active,
.user-menu-fade-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.user-menu-fade-enter,
.user-menu-fade-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.status-badge {
  background: #4caf50;
  color: white;
  padding: 5px 12px;
  border-radius: 18px;
  font-size: 0.9em;
  font-weight: 500;
}

.status-badge.ok {
  background: #4caf50;
}
.status-badge.error {
  background: #f44336;
}

.device-alert {
  margin: 8px 0 0 0;
  padding: 8px 12px;
  background: #fff3cd;
  border: 1px solid #ffeaa7;
  color: #8a6d3b;
  border-radius: 6px;
  display: flex;
  align-items: center;
  gap: 6px;
}

.status-time {
  color: #7f8c8d;
  font-size: 0.9em;
}
.status-time.clickable { cursor: pointer; text-decoration: underline dotted; }
.status-time-wrap { position: relative; display: inline-block; }
.inline-edit { display: inline-flex; align-items: center; gap: 6px; }
.inline-edit .name-input {
  width: 160px;
  height: 26px;
  line-height: 26px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 0 8px;
  outline: none;
}
.inline-edit .password-input {
  width: 160px;
  height: 26px;
  line-height: 26px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 0 8px;
  outline: none;
}
.inline-edit .password-input:focus { border-color: #409eff; }
.inline-edit .confirm-btn { padding: 4px 8px; }
.inline-name-editor .name-input {
  width: 100%;
  height: 28px;
  line-height: 28px;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  padding: 0 8px;
  outline: none;
}
.inline-name-editor .name-input:focus {
  border-color: #409eff;
}
.inline-name-editor .actions {
  margin-top: 6px;
  display: flex;
  justify-content: flex-end;
  gap: 6px;
}

.section-container {
  background: #f8f9fa;
  border-radius: 11px;
  padding: 12px;
  margin-bottom: 12px;
}

.section-container:last-child {
  margin-bottom: 0;
}

.section-title {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 12px;
  color: #2c3e50;
  font-weight: 600;
  font-size: 0.95em;
}

.section-title i {
  font-size: 1.1em;
  color: #2196f3;
}

.status-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 10px;
}

.status-item {
  background: #ffffff;
  border-radius: 10px;
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  min-width: 180px;
  max-width: 250px;
  margin: 0 auto;
}

.status-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
}

.status-icon {
  width: 36px;
  height: 36px;
  background: #e3f2fd;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.status-icon i {
  font-size: 19px;
  color: #2196f3;
}

.status-info {
  display: flex;
  flex-direction: column;
  gap: 2px;
  flex: 1;
  min-width: 0;
}

.status-label {
  color: #7f8c8d;
  font-size: 0.85em;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.status-value {
  color: #2c3e50;
  font-size: 1.05em;
  font-weight: 600;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.water-level {
  padding: 8px 0;
}

.water-bar {
  height: 18px;
  background: #e0e0e0;
  border-radius: 9px;
  overflow: hidden;
}

.water-fill {
  height: 100%;
  background: linear-gradient(90deg, #2196f3, #1976d2);
  width: 60%;
  border-radius: 9px;
  position: relative;
  overflow: hidden;
}

.water-fill::before,
.water-fill::after {
  content: "";
  position: absolute;
  width: 200%;
  height: 200%;
  background: rgba(255, 255, 255, 0.3);
  border-radius: 45%;
  top: -100%;
  left: -50%;
  animation: wave 3s linear infinite;
}

.water-fill::after {
  animation-delay: 1.5s;
  opacity: 0.5;
}

.fan-container {
  margin-left: auto;
}

.fan {
  width: 26px;
  height: 26px;
  position: relative;
}

.fan-blade {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #2196f3;
  border-radius: 50%;
  animation: rotate 2s linear infinite;
}

.fan-blade::before,
.fan-blade::after {
  content: "";
  position: absolute;
  width: 100%;
  height: 100%;
  background: #1976d2;
  border-radius: 50%;
}

.fan-blade::before {
  transform: rotate(120deg);
}

.fan-blade::after {
  transform: rotate(240deg);
}

.panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 15px;
}

.panel-header h2 {
  color: #2c3e50;
  font-size: 1.2em;
  margin: 0;
}

/* 概况可视化布局 */
.overview-content {
  display: grid;
  grid-template-columns: 320px 1fr;
  gap: 16px;
  align-items: stretch;
}

.tank-area {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.tank-meta {
  color: #2c3e50;
  font-weight: 600;
}

.tank {
  position: relative;
  width: 100%;
  max-width: 300px;
  height: 220px;
  border-radius: 14px 14px 10px 10px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.9),
    rgba(240, 240, 240, 0.9)
  );
  box-shadow: inset 0 0 0 2px rgba(0, 0, 0, 0.06),
    inset 0 8px 16px rgba(0, 0, 0, 0.05);
  overflow: hidden;
}

.tank-glass {
  position: absolute;
  inset: 0;
  pointer-events: none;
  background: linear-gradient(
    110deg,
    rgba(255, 255, 255, 0.55) 0%,
    rgba(255, 255, 255, 0.15) 30%,
    rgba(255, 255, 255, 0) 60%
  );
}

.tank-water {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  background: linear-gradient(180deg, #6ec5ff 0%, #3ea8ff 50%, #1f8ef3 100%);
  transition: height 0.6s ease;
  overflow: hidden; /* 让内部气泡被水面裁剪 */
  z-index: 1;
}

.water-wave {
  position: absolute;
  top: -8px;
  left: 0;
  width: 200%;
  height: 16px;
  background: radial-gradient(
      circle at 10px 8px,
      rgba(255, 255, 255, 0.8) 8px,
      rgba(255, 255, 255, 0) 9px
    )
    repeat-x;
  background-size: 20px 16px;
  opacity: 0.55;
  animation: waveSlide 6s linear infinite;
}

.water-wave.second {
  top: -4px;
  opacity: 0.35;
  animation-duration: 9s;
}

.tank-led {
  position: absolute;
  top: 10px;
  right: 10px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.06), 0 0 12px rgba(255, 213, 79, 0.7);
}

/* 顶部LED灯条 */
.tank-led-top {
  position: absolute;
  top: 6px;
  left: 10px;
  right: 10px;
  height: 8px;
  border-radius: 6px;
  background: #9e9e9e;
  opacity: 0.6;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);
}
.tank-led-top.active {
  opacity: 1;
  box-shadow: 0 0 10px rgba(255, 213, 79, 0.8);
}

/* LED光束效果 */
.led-beam {
  position: absolute;
  top: 14px;
  left: 10px;
  right: 10px;
  bottom: 0;
  pointer-events: none;
  background: linear-gradient(
    180deg,
    rgba(255, 235, 59, 0.28),
    rgba(255, 235, 59, 0.06) 40%,
    transparent 70%
  );
  filter: blur(0.5px);
}

/* 设备定位与效果 */
.device {
  position: absolute;
}
.device.fault::after,
.small-item b.fault::after,
.tank-led-top.fault::after {
  content: "";
  position: absolute;
  right: -4px;
  top: -4px;
  width: 8px;
  height: 8px;
  background: #f44336;
  border-radius: 50%;
  box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.9);
}
.small-item b.fault {
  color: #f44336;
}
.device.fault {
  filter: drop-shadow(0 0 4px rgba(244, 67, 54, 0.6));
}
.tank-led-top.fault {
  box-shadow: 0 0 10px rgba(244, 67, 54, 0.9);
}

/* 顶部扬声器 */
.device.buzzer {
  top: 18px;
  right: 16px;
  width: 16px;
  height: 16px;
}
.device.buzzer .sound-wave {
  position: absolute;
  top: 50%;
  left: 50%;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: #9e9e9e;
  transform: translate(-50%, -50%);
  opacity: 0.5;
}
.device.buzzer.active .sound-wave {
  animation: ping 1.8s infinite;
  background: #2196f3;
}
.device.buzzer .sound-wave.second {
  animation-delay: 0.9s;
}

@keyframes ping {
  0% {
    box-shadow: 0 0 0 0 rgba(33, 150, 243, 0.6);
    opacity: 1;
  }
  70% {
    box-shadow: 0 0 0 12px rgba(33, 150, 243, 0);
    opacity: 0.4;
  }
  100% {
    box-shadow: 0 0 0 0 rgba(33, 150, 243, 0);
    opacity: 0.2;
  }
}

/* 中部风扇 */
.device.fan {
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 40px;
  height: 40px;
}
.device.fan .fan-blade {
  position: absolute;
  inset: 0;
  background: #90caf9;
  border-radius: 50%;
}
.device.fan .icon-fan {
  width: 48px;
  height: 48px;
}
.device.fan.active .blades {
  transform-origin: 50% 50%;
  animation: rotate var(--fan-rotation, 0.9s) linear infinite;
}

/* 中上部雾化器 */
.device.ultra {
  top: 35%;
  left: 50%;
  transform: translateX(-50%);
}
.device.ultra .mist {
  display: block;
  width: 36px;
  height: 18px;
  background: radial-gradient(
    circle,
    rgba(255, 255, 255, 0.9),
    rgba(255, 255, 255, 0)
  );
  border-radius: 50%;
  opacity: 0;
}
.device.ultra.active .mist {
  animation: mistFloat 2.2s ease-in-out infinite;
}
/* svg 细雾点组动画 */
.device.ultra.active .mist-dots circle {
  animation: mistRise 2.4s ease-in-out infinite;
}
.device.ultra.active .mist-dots circle:nth-child(2) {
  animation-delay: 0.2s;
}
.device.ultra.active .mist-dots circle:nth-child(3) {
  animation-delay: 0.4s;
}
.device.ultra.active .mist-dots circle:nth-child(4) {
  animation-delay: 0.6s;
}
.device.ultra.active .mist-dots circle:nth-child(5) {
  animation-delay: 0.8s;
}
@keyframes mistRise {
  0% {
    transform: translateY(0);
    opacity: 0;
  }
  20% {
    opacity: 0.6;
  }
  60% {
    transform: translateY(-10px);
    opacity: 0.9;
  }
  100% {
    transform: translateY(-18px);
    opacity: 0;
  }
}
@keyframes mistFloat {
  0% {
    transform: translate(-50%, 0) scale(0.9);
    opacity: 0;
  }
  20% {
    opacity: 0.5;
  }
  50% {
    transform: translate(-50%, -14px) scale(1);
    opacity: 0.8;
  }
  100% {
    transform: translate(-50%, -26px) scale(1.05);
    opacity: 0;
  }
}

/* 底部增氧泵 */
.device.pump {
  bottom: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2;
}
.device.pump .pump-body {
  display: inline-block;
  width: 26px;
  height: 12px;
  background: #90caf9;
  border-radius: 6px;
  box-shadow: inset 0 0 0 1px rgba(0, 0, 0, 0.06);
}
.device.pump .pump-bubbles {
  position: absolute;
  bottom: 12px;
  left: 50%;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.9);
  transform: translateX(-50%);
  opacity: 0;
}
.bubble-field {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  pointer-events: none;
}
.bubble-field .bubble {
  position: absolute;
  bottom: 6px;
  width: 6px;
  height: 6px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.95);
  opacity: 0;
  animation: bubblesRise var(--bubble-speed, 2s) linear infinite;
}
.bubble-field .bubble.delay1 {
  animation-delay: 0.3s;
}
.bubble-field .bubble.delay2 {
  animation-delay: 0.6s;
}
.bubble-field .bubble.delay3 {
  animation-delay: 0.9s;
}
.bubble-field .bubble.delay4 {
  animation-delay: 1.2s;
}
@keyframes bubblesRise {
  0% {
    transform: translateY(0) scale(0.9);
    opacity: 0;
  }
  15% {
    opacity: 0.6;
  }
  60% {
    transform: translateY(-40%);
    opacity: 0.95;
  }
  100% {
    transform: translateY(-75%);
    opacity: 0;
  }
}

/* 液位传感器 */
.level-sensor {
  position: absolute;
  top: 14px;
  bottom: 10px;
  left: 8px;
  width: 10px;
  display: flex;
  align-items: flex-end;
  z-index: 2;
}
.level-sensor .sensor-track {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 4px;
  width: 2px;
  background: linear-gradient(180deg, #cfd8dc, #b0bec5);
  border-radius: 2px;
}
.level-sensor .sensor-indicator {
  position: absolute;
  left: 1px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: #ff7043;
  box-shadow: 0 0 0 2px rgba(0, 0, 0, 0.05);
  transform: translateY(50%);
}
.level-sensor .sensor-value {
  position: absolute;
  left: 18px;
  transform: translateY(50%);
  padding: 2px 6px;
  font-size: 11px;
  color: #1f4e79;
  background: rgba(255, 255, 255, 0.75);
  border: 1px solid #d1e3f3;
  border-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}
.level-sensor .sensor-tick {
  position: absolute;
  left: 0;
  display: flex;
  align-items: center;
  transform: translateY(50%);
}
.level-sensor .sensor-tick .tick-line {
  display: inline-block;
  width: 8px;
  height: 1px;
  background: #b0bec5;
  margin-left: 6px;
  opacity: 0.8;
}
.level-sensor .sensor-tick .tick-line.major {
  width: 10px;
  height: 2px;
  background: #90a4ae;
}
.level-sensor .sensor-tick .tick-label {
  display: inline-block;
  margin-left: 6px;
  font-size: 10px;
  color: #607d8b;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 3px;
  padding: 1px 3px;
}
.level-sensor .sensor-tick .tick-label.major {
  font-weight: 700;
  color: #455a64;
}
@keyframes bubbles {
  0% {
    transform: translate(-50%, 0) scale(0.9);
    opacity: 0;
  }
  30% {
    opacity: 0.8;
  }
  60% {
    transform: translate(-50%, -26px) scale(1);
    opacity: 0.9;
  }
  100% {
    transform: translate(-50%, -46px) scale(1.1);
    opacity: 0;
  }
}

/* 扬声器弧线动画 */
.device.buzzer .icon-buzzer {
  width: 28px;
  height: 28px;
}
.device.buzzer.active .buzzer-arcs {
  opacity: 1;
  animation: arcPulse 1.8s ease-out infinite;
}
@keyframes arcPulse {
  0% {
    opacity: 0;
  }
  20% {
    opacity: 0.7;
  }
  100% {
    opacity: 0.1;
  }
}

@keyframes waveSlide {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.readings-area {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.sensor-section,
.device-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.group-title {
  font-weight: 700;
  color: #2c3e50;
  font-size: 16px;
  margin-bottom: 8px;
  padding-bottom: 8px;
  border-bottom: 2px solid #e3f2fd;
}

.big-metrics {
  display: grid;
  grid-template-columns: repeat(2, minmax(120px, 1fr));
  gap: 12px;
}

@media (min-width: 1400px) {
  .big-metrics {
    grid-template-columns: repeat(4, minmax(120px, 1fr));
  }
}

.metric {
  background: #ffffff;
  border-radius: 10px;
  border: 1px solid #eef2f6;
  padding: 12px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.03);
}

.metric .label {
  color: #7f8c8d;
  font-size: 12px;
  margin-bottom: 4px;
}

.metric .value {
  color: #2c3e50;
  font-size: 22px;
  font-weight: 700;
}

.small-metrics {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 10px;
}

.small-item {
  background: #ffffff;
  border-radius: 10px;
  padding: 10px;
  display: grid;
  grid-template-columns: 20px 1fr auto;
  align-items: center;
  gap: 6px;
  border: 1px solid #eef2f6;
}

.small-item i {
  color: #2196f3;
}
.small-item span {
  color: #7f8c8d;
  font-size: 12px;
}
.small-item b {
  color: #2c3e50;
  font-size: 13px;
}

.task-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.task-item {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: all 0.3s ease;
}

.task-item:hover {
  background: #f0f2f5;
}

.task-content {
  display: flex;
  align-items: center;
  gap: 6px;
}

.task-content i {
  color: #4caf50;
}

.task-link {
  color: #2196f3;
  text-decoration: none;
  font-weight: 500;
  padding: 4px 8px;
  border-radius: 4px;
  transition: all 0.3s ease;
}

.task-link:hover {
  background: rgba(33, 150, 243, 0.1);
}

.record-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.record-item {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 10px;
  display: flex;
  align-items: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.3s ease;
}

.record-item:hover {
  background: #f0f2f5;
}

.record-item i {
  color: #2196f3;
}

.el-button {
  border-radius: 6px;
  padding: 6px 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 13px;
}

.el-button--primary {
  background: #2196f3;
  border-color: #2196f3;
}

.el-button--primary:hover {
  background: #1976d2;
  border-color: #1976d2;
}

.el-steps {
  margin: 15px 0;
}

.el-step__title {
  font-size: 13px;
  font-weight: 500;
  color: #2c3e50;
}

.el-step__description {
  font-size: 11px;
  color: #7f8c8d;
}

@keyframes rotate {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes wave {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

@media (max-width: 1200px) {
  .dashboard-container {
    padding: 10px;
  }

  .grid-content {
    padding: 12px;
  }
  .overview-content {
    grid-template-columns: 1fr;
  }
  .big-metrics {
    grid-template-columns: repeat(2, minmax(120px, 1fr));
  }
}

.section-container:nth-child(2) .status-grid {
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
}

.section-container:nth-child(3) .water-level {
  max-width: 400px;
  margin: 0 auto;
}

/* 作物选择弹窗样式 */
.crop-select-dialog {
  border-radius: 16px;
  overflow: hidden;
}

.crop-select-dialog .el-dialog__header {
  padding: 20px;
  background: #f8f9fa;
  border-bottom: 1px solid #e9ecef;
}

.crop-select-dialog .el-dialog__title {
  font-size: 1.4em;
  color: #2c3e50;
  font-weight: 600;
}

.crop-select-dialog .el-dialog__body {
  padding: 0;
}

.crop-select-container {
  padding: 20px;
}

.crop-select-header {
  text-align: center;
  margin-bottom: 20px;
}

.crop-select-header h3 {
  color: #2c3e50;
  font-size: 1.2em;
  margin: 0 0 10px 0;
}

.selected-crop {
  color: #7f8c8d;
  font-size: 0.95em;
}

.selected-crop span {
  color: #2196f3;
  font-weight: 600;
}

.crop-card {
  height: 100%;
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  padding: 20px;
}

.crop-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.crop-image {
  width: 80px;
  height: 80px;
  background: #e3f2fd;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 15px;
}

.crop-image i {
  font-size: 40px;
  color: #2196f3;
}

.crop-info {
  text-align: center;
}

.crop-info h4 {
  color: #2c3e50;
  font-size: 1.2em;
  margin: 0 0 8px 0;
}

.crop-desc {
  color: #7f8c8d;
  font-size: 0.9em;
  margin: 0;
}

.dialog-footer {
  text-align: center;
  padding: 20px;
  background: #f8f9fa;
  border-top: 1px solid #e9ecef;
  position: relative;
}

.button-group {
  display: flex;
  justify-content: center;
  gap: 16px;
  max-width: 400px;
  margin: 0 auto;
}

.dialog-footer .el-button {
  min-width: 140px;
  height: 40px;
  font-size: 14px;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  transition: all 0.3s ease;
}

.dialog-footer .el-button i {
  font-size: 16px;
}

.dialog-footer .cancel-btn {
  background: #f8f9fa;
  border: 1px solid #dcdfe6;
  color: #606266;
}

.dialog-footer .cancel-btn:hover {
  background: #f0f2f5;
  border-color: #c0c4cc;
  color: #303133;
}

.dialog-footer .confirm-btn {
  background: #2196f3;
  border-color: #2196f3;
  color: white;
}

.dialog-footer .confirm-btn:hover:not(:disabled) {
  background: #1976d2;
  border-color: #1976d2;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(33, 150, 243, 0.3);
}

.dialog-footer .confirm-btn:disabled {
  background: #a0cfff;
  border-color: #a0cfff;
  color: white;
  cursor: not-allowed;
}

/* 轮播图样式优化 */
.el-carousel__arrow {
  background-color: rgba(33, 150, 243, 0.8);
  border-radius: 50%;
  width: 36px;
  height: 36px;
}

.el-carousel__arrow:hover {
  background-color: #2196f3;
}

.el-carousel__indicators {
  bottom: -20px;
}

.el-carousel__indicator--active button {
  background-color: #2196f3;
}

.el-carousel__item {
  padding: 10px;
}
</style>